module.exports = __webpack_public_path__ + "src/img/time.3c99e78d.svg";